import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Thumbs, Autoplay } from 'swiper/modules';


const  slider = new Swiper(".myTeam", {
	modules: [Navigation, Pagination],

	slidesPerView: 1.3,
	spaceBetween: 16,
	loop: true,


	breakpoints: {

	  480: {
		slidesPerView: 1.3,
		spaceBetween: 20,

	  },
	  767: {
		slidesPerView: 1.4,
		spaceBetween: 40,

	  },
	  960: {
		slidesPerView: 2.2,
		spaceBetween: 40,

	  },

	  1280: {
		slidesPerView: 3,
		spaceBetween: 40,

	  }

	},
	navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
		el: ".swiper-pagination",
		clickable: true
	}

  });

const  info = new Swiper(".info", {
	modules: [Autoplay],

	slidesPerView: 1,
	loop: true,
	 autoplay: {
    delay: 4000, // 4000 ms = 4 sekundy
    disableOnInteraction: false // opcjonalnie: nie zatrzymuj autoplay po interakcji
  }

  });





